import { LOAD_BACKGROUNDS } from './../../action-types/backgrounds';

export const loadBackgrounds = (backgrounds, isSaved) => ({
  type: LOAD_BACKGROUNDS,
  backgrounds,
  isSaved,
});



// WEBPACK FOOTER //
// ./src/redux/actions/backgrounds/index.js